<template>
  <div>
    <b-container>
      <div class="row pt-3">
        <div class="col">
          <img src="./../../../assets/web/img/logo-pgj.png" alt="large" />
        </div>
        <div class="col d-none d-sm-block">
          <a href="#/login" class="float-right pt-3">
            已有账户？请登录>
          </a>
        </div>
      </div>
    </b-container>
    <b-container
      fluid
      class="my-2 bg-light"
      style="border-bottom: 1px solid #eee; border-top: 1px solid #eee;"
    >
        <div class="container pt-4" >
            <form class="py-1" style="max-width: 500px;margin: 0 auto;">
              <validation-observer ref="userRegForm">
                <h4 class="pb-4">用户注册<br>
                <small class="text-muted"><small>注册为集团用户后，可以管理多个税号的企业</small></small>
                </h4>
                <div id="alert"></div>
                <validation-provider
                    :rules="{required:true, min:2, max:10}"
                    name="集团简称"
                    v-slot="validationContext"
                    >
                    <b-form-group 
                        label-cols="4"
                        label="集团简称:" 
                        :invalid-feedback="validationContext.errors[0]">
                        <b-form-input 
                            name="field"
                            v-model="userRegDto.orgName" 
                            :state="validateState(validationContext)"
                            placeholder="请输入集团简称">
                        </b-form-input>
                    </b-form-group>
                </validation-provider>

                <validation-provider
                    :rules="{required:true, min:18, max:20}"
                    name="公司税号"
                    v-slot="validationContext"
                    >
                    <b-form-group 
                        label-cols="4"
                        label="公司税号:" 
                        :invalid-feedback="validationContext.errors[0]">
                        <b-form-input 
                            name="field"
                            v-model="userRegDto.entCode" 
                            :state="validateState(validationContext)"
                            placeholder="请输入公司税号">
                        </b-form-input>
                    </b-form-group>
                </validation-provider>

                <validation-provider
                    :rules="{required:true, min:2, max:100}"
                    name="公司名称"
                    v-slot="validationContext"
                    >
                    <b-form-group 
                        label-cols="4"
                        label="公司名称:" 
                        :invalid-feedback="validationContext.errors[0]">
                        <b-form-input 
                            name="field"
                            v-model="userRegDto.entName" 
                            :state="validateState(validationContext)"
                            placeholder="请输入公司名称">
                        </b-form-input>
                    </b-form-group>
                </validation-provider>

                <validation-provider
                    :rules="{required:true, max:5}"
                    name="姓名"
                    v-slot="validationContext"
                    >
                    <b-form-group label="姓名:" label-cols="4" :invalid-feedback="validationContext.errors[0]" >
                        <b-form-input 
                            name="field"
                            v-model="userRegDto.userFullName" 
                            :state="validateState(validationContext)"
                            placeholder="姓名">
                        </b-form-input>
                    </b-form-group>
                </validation-provider>

                <validation-provider
                    :rules="{required:true, regex:/1[3|4|5|7|8][0-9]\d{8}/}"
                    name="手机号"
                    v-slot="validationContext"
                    >
                    <b-form-group label="手机号:" label-cols="4" :invalid-feedback="validationContext.errors[0]" >
                        <b-form-input 
                            name="field"
                            v-model="userRegDto.mobile" 
                            :state="validateState(validationContext)"
                            placeholder="手机号">
                        </b-form-input>
                    </b-form-group>
                </validation-provider>

                <validation-provider
                    :rules="{required:true, min:6, max:20, regex:/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/}"
                    name="密码"
                    v-slot="validationContext"
                    vid="newPassword1"
                    >
                    <b-form-group label="密码:" label-cols="4" :invalid-feedback="validationContext.errors[0]" >
                        <b-form-input 
                            name="field"
                            v-model="userRegDto.password" 
                            :state="validateState(validationContext)"
                            type="password"
                            placeholder="字母数字组合,6到20个字符">
                        </b-form-input>
                    </b-form-group>
                </validation-provider>

                <validation-provider
                    :rules="{required:true, confirmed: 'newPassword1'}"
                    name="确认密码"
                    v-slot="validationContext"
                    >
                    <b-form-group label="确认密码:" label-cols="4" :invalid-feedback="validationContext.errors[0]" >
                        <b-form-input 
                            name="field"
                            v-model="userRegDto.passwordConfirm" 
                            :state="validateState(validationContext)"
                            type="password"
                            placeholder="确认密码">
                        </b-form-input>
                    </b-form-group>
                </validation-provider>

                <validation-provider
                    :rules="{max: 8}"
                    name="渠道编码"
                    v-slot="validationContext"
                    >
                    <b-form-group label="渠道编码:" label-cols="4" :invalid-feedback="validationContext.errors[0]" >
                        <b-form-input 
                            name="field"
                            v-model="userRegDto.invitationCode" 
                            :state="validateState(validationContext)"
                            placeholder="渠道编码">
                        </b-form-input>
                    </b-form-group>
                </validation-provider>

                <validation-provider
                    name="验证码"
                    v-slot="validationContext"
                    >
                    <b-form-group label="验证码:" label-cols="4" :invalid-feedback="validationContext.errors[0]" >
                        <b-input-group>
                            <b-form-input 
                                name="field"
                                ref="veriCodeInput"
                                v-model="userRegDto.verificationCode" 
                                :state="validateState(validationContext)"
                                type="password"
                                placeholder="验证码">
                            </b-form-input>
                            <b-input-group-append>
                                <b-button :disabled="!canClick" variant="info" @click="openVerify">{{content}}</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </validation-provider>

                <div class="form-group row">
                <div class="col-md-12">
                    <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="gridCheck1" v-model="isAgreement">
                    <label class="form-check-label" for="gridCheck1">
                        我已阅读并同意
                    </label>
                    <a href="#" @click="openLicense">《瑞宏网票管家用户服务协议》</a>
                    </div>
                </div>
                </div>
                <div class="form-group row">
                    <div class="col-md-12">
                        <button type="button" @click="handleSave" :disabled="!isAgreement" class="btn btn-danger btn-block">注册</button>
                    </div>
                </div>
              </validation-observer>
            </form>

        </div>
    </b-container>

    <b-modal
      id="verifyModal"
      ref="modal-verify"
      v-model="verifyVisible"
      centered
      size="md"
      hide-footer
      style="max-width:200px"
      title="请完成以下拼图验证"
    >
      <!-- :imgSize="{ width: '470px', height: '250px' }" -->
      <Verify @success="handelGetVerifyCode" :mode="'fixed'" :captchaType="'blockPuzzle'" ref="verify" />
    </b-modal>

    <!-- 用户注册协议 -->
    <b-modal
      id="license"
      ref="modal-license"
      v-model="licenseVisible"
      centered
      size="lg"
      title="服务协议"
      @ok="handleAgree"
      @cancel="handleDisagree"
    >
      <template slot="modal-ok">同意</template>
      <template slot="modal-cancel">拒绝</template>
      <b-form-textarea
        id="textarea-rows"
        placeholder="Tall textarea"
        rows="16"
        v-model="licenseText"
      ></b-form-textarea>
    </b-modal>

  </div>
</template>

<script>
import * as userFacade from "../../../api/user-facade.js";
import Verify from "@/components/captcha/Verify.vue";

export default {
  components: {
    Verify
  },
  // validations:
  data() {
    return {
        userRegDto:{},
        isAgreement: false,
        content: '发送验证码',
        totalTime: 60,
        canClick: true, //添加canClick
        verifyVisible: false,
        licenseVisible: false,
        licenseText:'',
    };
  },

  created() {},
  mounted() {
      
  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    openVerify() {
      this.$refs.userRegForm.validate().then(valid => {
        if (valid) {
          //let param = { captchaVerification: "11" };
          //this.handleLogin(param);
          this.verifyVisible = true;
        } else {
          // 登录表单校验失败
          this.$message({
            message: "请填写正确的注册信息",
            type: "danger"
          });
        }
      });
    },

    // 打开用户许可界面
    openLicense(){
      this.licenseVisible = true;
      this.getLicense()
    },
    // 获取验证码
    handelGetVerifyCode(params){
        this.verifyVisible = false;
        this.userRegDto.captchaVerification = params.captchaVerification;
        userFacade
            .getVeriCode(this.userRegDto)
            .then(()=>{
              this.countDown()
            })
            .catch(err => {
              console.log("err", err);
            });
    },
    // 注册
    handleSave(){
      this.$refs.userRegForm.validate().then(valid => {
        if (valid) {
            // 判断校验码是否录入
            if(this.userRegDto.verificationCode == null){
                    this.$message({
                        message: "输入验证码",
                        type: "danger"
                    });
                    this.$refs.veriCodeInput.focus();
                    return
            }

            // 执行用户注册
            userFacade
            .register(this.userRegDto)
            .then(()=>{
              this.$message({
                message: "用户注册成功",
                type: "success"
              });

              // 跳转到登录页面进行登录
              let var1 = this;
              setTimeout(function() {
                var1.$router.replace("/login")
              }, 3000);

              this.resetForm();              
            })
            .catch(err => {
              console.log("err", err);
              this.pageLoading = false;
            });
        }
      })
    },
    // 充值表单
    resetForm() {
      this.pwdChangeDto = {      };

      this.$nextTick(() => {
        this.$refs.userRegForm.reset();
      });
    },

    countDown () {
        if (!this.canClick) return //改动的是这两行代码
        this.canClick = false
        this.content = this.totalTime + 's'
        let clock = window.setInterval(() => {
            this.totalTime--
            this.content = this.totalTime + 's'
            if (this.totalTime < 0) {
                window.clearInterval(clock)
                this.content = '发送验证码'
                this.totalTime = 60
                this.canClick = true //这里重新开启
            }
        }, 1000)
    },

    // 读取license.txt文件
    getLicense() {
        //  更新数据devInfo.txt文件接口      
        let xhr = new XMLHttpRequest(),
        okStatus = document.location.protocol === "file:" ? 0 : 200;
        console.log(okStatus)
        xhr.open('GET', '../../../license.txt', false);// 文件路径
        xhr.overrideMimeType("text/html;charset=utf-8");//默认为utf-8
        xhr.send(null);
        this.licenseText=(xhr.responseText); //打印文件信息
    },

    // 同意许可
    handleAgree(){
      this.isAgreement = true
    },
    handleDisagree(){
      this.isAgreement = false;
    },
  }
};
</script>

<style >
</style>
